import Invoices from "./components/Invoices";

export default Invoices;
